import React, { useState } from 'react';
// import './App.css';

function App() {
  const [input, setInput] = useState('');
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    setLoading(true);
    setResponse('');

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/users/userReduce`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          message: input,
          model: 'deepseek-r1' // Change this to your local model name
        }),
      });

      const data = await res.json();
      if (data.response) {
        setResponse(data.response);
      } else {
        setResponse('Error: No hay respuesta recivida.');
      }
    } catch (err) {
      setResponse('Error al conectar con el backend server.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '600px', margin: '50px auto', padding: '20px', fontFamily: 'Arial' }}>
      <h5>Asistente Ollama AI</h5>
      <form onSubmit={handleSubmit} className='' >
        <input
          type="text"
          className='form-control'
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Pregunta algo..."
          disabled={loading}
        />
        <button type="submit" className='btn btn-warning text-center w-100' disabled={loading}>
          {loading ? 'Pensando...' : 'Send'}
        </button>
      </form>
      <div style={{ marginTop: '20px', padding: '15px', background: '#f4f4f4', borderRadius: '5px', minHeight: '100px', whiteSpace: 'pre-wrap' }}>
        <strong>Respuesta:</strong>
        <p>{response}</p>
      </div>
    </div>
  );
}

export default App